import { FunctionComponent } from 'react'
import { Daycare } from '@/types/Daycare'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import styles from './confirmUnlinkDaycareDialog.module.scss'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { UNLINK_DAYCARE_FROM_GROUP } from '@/modules/API/daycareGroup/daycareLinkHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmUnlinkDaycareDialogProps {
    open: boolean
    handleClose: () => void
    daycare: Daycare | null
    refetchGroups: () => void
}

const ConfirmUnlinkDaycareDialog: FunctionComponent<ConfirmUnlinkDaycareDialogProps> = ({
    open,
    handleClose,
    daycare,
    refetchGroups
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [unlinkDaycare] = useMutation(UNLINK_DAYCARE_FROM_GROUP, {
        variables: {
            daycareId: daycare?.id
        },
        onCompleted: () => {
            showNotificationSuccess(t('daycareUnlinked'))
            refetchGroups()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorUnlinkingDaycare'))
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmUnlinkDaycare')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmUnlinkDaycareMessage')}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={unlinkDaycare}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmUnlinkDaycareDialog
